// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Employee profile (Stitch: Employee profile — Sara Khalil) ——— */
.employee-profile {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 24px;
}

@media (min-width: 1024px) {
  .employee-profile {
    padding: 32px;
  }
}

.employee-profile__inner {
  box-sizing: border-box;
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

.employee-profile__inner > .ant-spin-nested-loading,
.employee-profile__inner > .ant-spin-nested-loading > .ant-spin-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

/* ——— Hero ——— */
.employee-profile__hero {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 28px;
  margin-bottom: 32px;
  border-bottom: 1px solid #E2E8F0;
}

@media (min-width: 640px) {
  .employee-profile__hero {
    flex-direction: row;
    align-items: center;
    padding-bottom: 32px;
    margin-bottom: 40px;
  }
}

.employee-profile__hero-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.employee-profile__back {
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #64748B;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
}

.employee-profile__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .employee-profile__back .anticon {
  transform: scaleX(-1);
}

.employee-profile__avatar {
  box-sizing: border-box;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid #E0F2FE;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.employee-profile__hero-text {
  min-width: 0;
}

.employee-profile__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.employee-profile__title-row h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #0F172A;
}

.employee-profile__role-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 9999px;
  border: 1px solid #BAE6FD;
  background: #F0F9FF;
  color: #0369A1;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
}

.employee-profile__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
}

.employee-profile__status.is-active {
  border: 1px solid rgba(16, 185, 129, 0.2);
  background: #ECFDF5;
  color: #10B981;
}

.employee-profile__status.is-archived {
  border: 1px solid #FECACA;
  background: #FEF2F2;
  color: #DC2626;
}

.employee-profile__status--compact {
  border-radius: 4px;
}

.employee-profile__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
}

.employee-profile__meta {
  margin: 4px 0 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  line-height: 18px;
  color: #64748B;
}

.employee-profile__meta .is-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.employee-profile__meta-sep {
  color: #CBD5E1;
}

.employee-profile__hero-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.employee-profile__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.employee-profile__btn--secondary {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #0F172A;
}

.employee-profile__btn--secondary:hover {
  background: #F8FAFC;
}

.employee-profile__btn--secondary .anticon {
  font-size: 15px;
  color: #64748B;
}

.employee-profile__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.employee-profile__btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.employee-profile__btn--primary .anticon {
  font-size: 15px;
}

/* ——— Cards ——— */
.employee-profile__cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  min-width: 0;
}

@media (min-width: 768px) {
  .employee-profile__cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }
}

.employee-profile__card {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  padding: 20px;
  min-width: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.employee-profile__card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
  margin-bottom: 4px;
  border-bottom: 1px solid #F1F5F9;
}

.employee-profile__card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.employee-profile__card-title h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.employee-profile__card-icon-wrap {
  box-sizing: border-box;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #E0F2FE;
  background: #F0F9FF;
  color: #0284C7;
  font-size: 14px;
}

.employee-profile__id-badge {
  flex-shrink: 0;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 500;
  color: #94A3B8;
}

.employee-profile__id-badge.is-mono,
.employee-profile__rows .is-mono,
.employee-profile__rows dd.is-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.employee-profile__verified {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #94A3B8;
}

.employee-profile__verified .anticon {
  font-size: 12px;
  color: #10B981;
}

.employee-profile__rows {
  display: flex;
  flex-direction: column;
  margin: 0;
}

.employee-profile__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #F1F5F9;
  font-size: 12px;
}

.employee-profile__row.is-last {
  border-bottom: none;
  padding-bottom: 0;
}

.employee-profile__row dt {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #94A3B8;
  min-width: 0;
}

.employee-profile__row dt .anticon {
  font-size: 14px;
  color: #94A3B8;
  flex-shrink: 0;
}

.employee-profile__row dd {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: #1E293B;
  line-height: 1.45;
  min-width: 0;
  word-break: break-word;
}

.employee-profile__row dd.is-strong,
.employee-profile__rows .is-strong {
  font-weight: 600;
  color: #0F172A;
}

.employee-profile__muted {
  color: #94A3B8;
}

.employee-profile__link {
  color: #0EA5E9;
  text-decoration: none;
  font-weight: 500;
}

.employee-profile__link:hover {
  text-decoration: underline;
}

.employee-profile__footer {
  margin-top: 4px;
  padding-top: 8px;
}

.employee-profile__footer p {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #94A3B8;
}

@media print {
  .employee-profile__back,
  .employee-profile__hero-actions {
    display: none !important;
  }

  .employee-profile {
    padding: 0;
  }

  .employee-profile__card {
    box-shadow: none;
    break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowEmployee/style.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;EACX;AACF;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,6EAA6E;EAC7E,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":["/* ——— Employee profile (Stitch: Employee profile — Sara Khalil) ——— */\n.employee-profile {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 24px;\n}\n\n@media (min-width: 1024px) {\n  .employee-profile {\n    padding: 32px;\n  }\n}\n\n.employee-profile__inner {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 72rem;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n.employee-profile__inner > .ant-spin-nested-loading,\n.employee-profile__inner > .ant-spin-nested-loading > .ant-spin-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n/* ——— Hero ——— */\n.employee-profile__hero {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 28px;\n  margin-bottom: 32px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n@media (min-width: 640px) {\n  .employee-profile__hero {\n    flex-direction: row;\n    align-items: center;\n    padding-bottom: 32px;\n    margin-bottom: 40px;\n  }\n}\n\n.employee-profile__hero-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.employee-profile__back {\n  box-sizing: border-box;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #64748B;\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n\n.employee-profile__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .employee-profile__back .anticon {\n  transform: scaleX(-1);\n}\n\n.employee-profile__avatar {\n  box-sizing: border-box;\n  width: 48px;\n  height: 48px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  border: 1px solid #E0F2FE;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.employee-profile__hero-text {\n  min-width: 0;\n}\n\n.employee-profile__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.employee-profile__title-row h1 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: #0F172A;\n}\n\n.employee-profile__role-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  border: 1px solid #BAE6FD;\n  background: #F0F9FF;\n  color: #0369A1;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.employee-profile__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.employee-profile__status.is-active {\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  background: #ECFDF5;\n  color: #10B981;\n}\n\n.employee-profile__status.is-archived {\n  border: 1px solid #FECACA;\n  background: #FEF2F2;\n  color: #DC2626;\n}\n\n.employee-profile__status--compact {\n  border-radius: 4px;\n}\n\n.employee-profile__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n}\n\n.employee-profile__meta {\n  margin: 4px 0 0;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  font-size: 12px;\n  line-height: 18px;\n  color: #64748B;\n}\n\n.employee-profile__meta .is-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n}\n\n.employee-profile__meta-sep {\n  color: #CBD5E1;\n}\n\n.employee-profile__hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.employee-profile__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.employee-profile__btn--secondary {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #0F172A;\n}\n\n.employee-profile__btn--secondary:hover {\n  background: #F8FAFC;\n}\n\n.employee-profile__btn--secondary .anticon {\n  font-size: 15px;\n  color: #64748B;\n}\n\n.employee-profile__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.employee-profile__btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.employee-profile__btn--primary .anticon {\n  font-size: 15px;\n}\n\n/* ——— Cards ——— */\n.employee-profile__cards {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  min-width: 0;\n}\n\n@media (min-width: 768px) {\n  .employee-profile__cards {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 20px;\n  }\n}\n\n.employee-profile__card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 16px;\n  padding: 20px;\n  min-width: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.employee-profile__card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 12px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.employee-profile__card-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.employee-profile__card-title h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.employee-profile__card-icon-wrap {\n  box-sizing: border-box;\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  border: 1px solid #E0F2FE;\n  background: #F0F9FF;\n  color: #0284C7;\n  font-size: 14px;\n}\n\n.employee-profile__id-badge {\n  flex-shrink: 0;\n  max-width: 50%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 11px;\n  font-weight: 500;\n  color: #94A3B8;\n}\n\n.employee-profile__id-badge.is-mono,\n.employee-profile__rows .is-mono,\n.employee-profile__rows dd.is-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n}\n\n.employee-profile__verified {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #94A3B8;\n}\n\n.employee-profile__verified .anticon {\n  font-size: 12px;\n  color: #10B981;\n}\n\n.employee-profile__rows {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n}\n\n.employee-profile__row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid #F1F5F9;\n  font-size: 12px;\n}\n\n.employee-profile__row.is-last {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.employee-profile__row dt {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #94A3B8;\n  min-width: 0;\n}\n\n.employee-profile__row dt .anticon {\n  font-size: 14px;\n  color: #94A3B8;\n  flex-shrink: 0;\n}\n\n.employee-profile__row dd {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 400;\n  color: #1E293B;\n  line-height: 1.45;\n  min-width: 0;\n  word-break: break-word;\n}\n\n.employee-profile__row dd.is-strong,\n.employee-profile__rows .is-strong {\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.employee-profile__muted {\n  color: #94A3B8;\n}\n\n.employee-profile__link {\n  color: #0EA5E9;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.employee-profile__link:hover {\n  text-decoration: underline;\n}\n\n.employee-profile__footer {\n  margin-top: 4px;\n  padding-top: 8px;\n}\n\n.employee-profile__footer p {\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: #94A3B8;\n}\n\n@media print {\n  .employee-profile__back,\n  .employee-profile__hero-actions {\n    display: none !important;\n  }\n\n  .employee-profile {\n    padding: 0;\n  }\n\n  .employee-profile__card {\n    box-shadow: none;\n    break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
